let getTokenSilently = null;

export const setGetAccessToken = (func) => {
  getTokenSilently = func;
};

export const getToken = async () => {
  if (!getTokenSilently) {
    // console.error("getAccessTokenSilently function is not set.");
    return null;
  }

  try {
    const token = await getTokenSilently(); // ✅ Call the real function
    console.log("Token received:", token);
    if (token) {
      localStorage.setItem("Token", token);
      return token;
    } else {
      console.warn("No token received from getAccessTokenSilently.");
      return "";
    }
  } catch (error) {
    console.error("Error fetching token:", error);
    return "";
  }
};
